module.exports = __webpack_public_path__ + "img/6.2f470fc1.png";